<template>
  <listSuncategoriesMarketplaceComponent 
  :category = "category"
  />
</template>

<script>
import listSuncategoriesMarketplaceComponent from "@/views/categories_marketplace/pages/list_subcategories_marketplace/components/list_subcategories_marketplace_component.vue";
export default {
  name: "categories",
  components: {
    listSuncategoriesMarketplaceComponent,
  },
  props: {
    category: {
      required: true
    },
  },
};
</script>

<style lang="css" scoped>
</style>
